import React, { useEffect, useMemo, useState } from "react";
import Chair from "./blocks/Chair";
import MiladMap from "./blocks/MiladMap";
import { HiOutlineTicket } from "react-icons/hi";
import { BiSearch, BiTrash, BiZoomIn, BiZoomOut } from "react-icons/bi";
import moneyFormat from "../../base/utils/moneyFormat";
import ChairSamples from "./blocks/ChairSamples";
import Lable from "../../base/features/micro/Lable";
import fixNumbers from "../../base/utils/fix_Numbers";
import { useParams } from "react-router-dom";
import { apiService } from "../../base/service/service";
import ScrollContainer from "react-indiana-drag-scroll";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BsTrash } from "react-icons/bs";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

export default function TicketSell() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const { sceneToken, eventId } = useParams();
  const [seats, setSeats] = useState(null);
  const [parts, setParts] = useState(null);
  const [selectedPart, setSelectedPart] = useState(null);
  const [selectedTickets, setSelectedTickets] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [pending, setPending] = useState(false);
  const [discountPending, setDiscountPending] = useState(false);
  const [expire_time, setExpireTime] = useState(null);
  const [showDiscount, setShowDiscount] = useState(false);
  const [discount, setDiscount] = useState("");
  const [acceptDiscount, setAcceptDiscount] = useState("");
  const [selectedZoom, setSelectedZoom] = useState(80);
  const [authConfirmMode, setAuthConfirmMode] = useState(false);
  const [login_expire_time, setLoginExpireTime] = useState(null);
  const [code, setCode] = useState("");
  const [confirmPending, setConfirmPending] = useState(false);
  const [salonData, setSalonData] = useState(null);

  const maxZoom = 140;
  const minZoom = 60;
  const zoomStep = 20;

  useEffect(() => {
    getConcerts();
    setExpireTime(5);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      expire_time > 0
        ? setExpireTime((time) => time - 1)
        : clearInterval(interval);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [expire_time]);

  useEffect(() => {
    if (login_expire_time) {
      const interval = setInterval(() => {
        setLoginExpireTime((time) => time - 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [login_expire_time]);

  useEffect(() => {
    scrollToCenter();
  }, [selectedPart]);

  const selectedSeatIds = useMemo(
    () => new Set(selectedTickets?.map((t) => t.id) || []),
    [selectedTickets]
  );

  function getConcerts() {
    apiService({
      url: `api/events/event_date_details/${eventId}/date/${sceneToken}`,
    }).then((data) => {
      if (data && data?.success === 1) {
        setSeats(data.seats);
        setSalonData(data.salon_data);
      }
    });
  }
  function plusNumbers(tickets) {
    let calculatedPrice = 0;
    tickets.map((ticket, t) => {
      calculatedPrice = calculatedPrice + ticket.price;
    });
    let cal_price;
    if (acceptDiscount) {
      if (acceptDiscount.amount_type === "percent") {
        cal_price =
          calculatedPrice - (calculatedPrice * acceptDiscount.amount) / 100;
        return cal_price + cal_price * 0.1;
      } else {
        cal_price = calculatedPrice - acceptDiscount.amount;
        return cal_price + cal_price * 0.1;
      }
    } else {
      return calculatedPrice + calculatedPrice * 0.1;
    }
  }
  function addToCart(item, i) {
    if (selectedTickets) {
      let new_ticket = selectedTickets?.find((ticket) => ticket.id === item.id);

      if (!new_ticket) {
        setSelectedTickets((prev) => [...prev, item]);
      } else {
        setSelectedTickets((prev) =>
          prev.filter((item) => item.id !== new_ticket.id)
        );
      }
    } else {
      setSelectedTickets([item]);
    }
  }
  function checkDiscount() {
    if (!discount) {
      Swal.fire({
        text: "کد تخفیف وارد کنید",
        showConfirmButton: false,
        toast: true,
        customClass: {
          htmlContainer: "text-center m-0",
        },
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }
    setDiscountPending(true);
    apiService({ url: `api/user/discount/check/${discount}` }).then((data) => {
      if (data && data.success === 1) {
        setShowDiscount(false);
        setAcceptDiscount(data.discount);
        Swal.fire({
          text: "کد تخفیف با موفقیت اعمال شد",
          showConfirmButton: false,
          toast: true,
          customClass: {
            htmlContainer: "text-center m-0",
          },
          timer: 3000,
          timerProgressBar: true,
        });
      }
      setDiscountPending(false);
    });
  }
  function pay() {
    if (!selectedTickets || (selectedTickets && selectedTickets.length === 0)) {
      Swal.fire({
        text: "صندلی انتخاب کنید",
        showConfirmButton: false,
        toast: true,
        customClass: {
          htmlContainer: "text-center m-0",
        },
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }
    if (name.length < 3) {
      Swal.fire({
        text: "نام و نام خانوادگی خود را بنویسید",
        showConfirmButton: false,
        toast: true,
        customClass: {
          htmlContainer: "text-center m-0",
        },
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }
    if (phone.length !== 11 || !phone.startsWith("09")) {
      Swal.fire({
        text: "شماره تلفن همراه صحیح نمی باشد",
        showConfirmButton: false,
        toast: true,
        customClass: {
          htmlContainer: "text-center m-0",
        },
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }
    let isIncorrectFreeChair = false;
    selectedTickets.map((chair, c) => {
      let main_chair_index = seats.findIndex((seat) => seat.id === chair.id);
      let next1 = seats[main_chair_index + 1];
      let next2 = seats[main_chair_index + 2];
      let past1 = seats[main_chair_index - 1];
      let past2 = seats[main_chair_index - 2];
      if (
        next1?.status === "available" &&
        next1?.type === "select" &&
        (next2?.status !== "available" || next2?.type !== "select") &&
        !selectedTickets.find((ticketItem) => ticketItem.id === next1.id)
      ) {
        isIncorrectFreeChair = true;
      }
      if (
        past1?.status === "available" &&
        past1?.type === "select" &&
        (past2?.status !== "available" || past2?.type !== "select") &&
        !selectedTickets.find((ticketItem) => ticketItem.id === past1.id)
      ) {
        isIncorrectFreeChair = true;
      }
    });

    if (isIncorrectFreeChair) {
      Swal.fire({
        text: "لطفا بین صندلی های انتخابی تک صندلی باقی نگذارید",
        showConfirmButton: false,
        toast: true,
        customClass: {
          htmlContainer: "text-center m-0",
        },
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }
    setPending(true);
    let chairs = [];
    selectedTickets.map((item, i) => {
      chairs.push(item.id);
    });
    let data = {
      name: name,
      phone: phone,
      event_id: eventId,
      event_seats_ids: chairs,
    };
    if (discount) {
      data.discount_code = discount;
    }
    if (window.Android) {
      data.client = "android";
    }
    apiService({
      url: `api/events/payment/buy_ticket`,
      methodType: "post",
      body: data,
    }).then((data) => {
      if (data?.success === 1) {
        if (window.Android) {
          window.Android.openPaymentLink(data.url?.url);
        } else {
          window.location.href = data.url?.url;
        }
      }
      if (data?.success === 3) {
        Swal.fire({
          text: data.description,
          icon: "success",
          confirmButtonText: "تایید",
        }).then(() => (window.location.href = "/my-ticket-list"));
      }
      if (data?.success === 4) {
        Swal.fire({
          text: data.description,
          icon: "success",
          confirmButtonText: "تایید",
        });
      }
      if (data?.success === 0) {
        getConcerts();
      }
      setPending(false);
    });
  }
  function auth() {
    setPending(true);
    apiService({
      url: `api/user/login`,
      methodType: "get",
      params: {
        phone: phone,
        city: "tabriz",
      },
    }).then((data) => {
      setPending(false);
      if (data?.success === 1) {
        setAuthConfirmMode(true);
        document.getElementById("code")?.focus();
        setLoginExpireTime(120);
      }
    });
  }
  function scrollToCenter() {
    const flavoursContainer = document.getElementsByClassName("scrollBox")[0];
    window.setTimeout(() => {
      flavoursContainer?.scrollTo(
        (flavoursContainer.scrollWidth - flavoursContainer.clientWidth) / 2,
        0
      );
    }, 500);
  }

  function authConfirm() {
    setConfirmPending(true);
    let params = {
      client_secret: "WCRQutwCKMyj5okZR94aARc0IgO3mC6NEt2MekXu",
      grant_type: "password",
      client_id: 4,
      user_type: "user",
      username: phone,
      password: code,
    };
    apiService({ url: `oauth/token`, methodType: "post", body: params }).then(
      (data) => {
        if (data) {
          if (data && data.access_token) {
            localStorage.setItem(
              `token`,
              data.token_type + " " + data.access_token
            );
            setToken(data.token_type + " " + data.access_token);
            setAuthConfirmMode(false);
            Swal.fire({
              icon: "success",
              text: "اطلاعات شما تایید شد ادامه فرایند را طی کنید",
              confirmButtonText: "ادامه",
            }).then(({ isConfirmed }) => {
              if (isConfirmed) {
                pay();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "کد وارد شده اشتباه است",
              confirmButtonText: "تایید",
              timer: 3000,
            });
          }
        }
        setConfirmPending(false);
      }
    );
  }
  return (
    <div className="container-fluid pb-4">
      <div className="row mx-0 bg-light-gray p-2 rounded10 mt-3">
        <div className="col-12 px-0 text-center">
          <p
            className="mb-2 fs-5 bg-main rounded-4 py-2 text-white"
            onClick={() => scrollToCenter()}
          >
            سن
          </p>
          {/* {parts ? (
            <MiladMap
              parts={parts}
              selectedPart={selectedPart}
              picSelectedPart={(partName) =>
                parts.filter((item) => item.name1 === partName).length !== 0 &&
                setSelectedPart(
                  parts.filter((item) => item.name1 === partName)[0]
                )
              }
            />
          ) : (
            <div className="text-center py-3 mt-5">
              <Spinner
                size="sm"
                className="align-middle text-main"
                animation="border"
              />
            </div>
          )} */}
        </div>
        <div dir="ltr" className={`col-12 px-0`}>
          {/* <div className="row mx-0 mb-3 position-relative">
            <div className="col-12 px-0 text-center">
              <span className="small fw-bolder border border-dark border-2 rounded10 px-3">
                {selectedPart?.name1}
              </span>
            </div>
          </div> */}
          <div className="position-relative">
            {seats && salonData && (
              <TransformWrapper
                initialScale={salonData.initialScale || 0.6}
                minScale={salonData.minScale || 0.6}
                maxScale={salonData.maxScale || 4}
                wheel={{ step: 0.2 }} // zoom with scroll on desktop
                pinch={{ step: 5 }} // pinch degree on mobile
              >
                <TransformComponent
                  wrapperClass="w-100"
                  wrapperStyle={{ maxHeight: "400px" }}
                >
                  <div style={{ width: salonData.salon_width || "460px" }}>
                    <div className="mx-0" dir={salonData.direction || "ltr"}>
                      {seats?.map((chair, i) => (
                        <Chair
                          key={chair.id}
                          setSelectedSeat={() =>
                            (chair.status === "available" ||
                              chair.status === "reserved") &&
                            addToCart(chair, i)
                          }
                          is_selected={selectedSeatIds.has(chair.id)}
                          item={chair}
                          isRow={
                            seats[i - 1]?.row_number !== chair.row_number &&
                            i !== 0
                          }
                        />
                      ))}
                    </div>
                  </div>
                </TransformComponent>
              </TransformWrapper>
            )}
            {!seats && (
              <div className="text-center w-100">
                <div className="text-center py-3 mt-5">
                  <Spinner
                    size="sm"
                    className="align-middle text-main"
                    animation="border"
                  />
                </div>
              </div>
            )}
            {/* {expire_time > 0 && (
              <img
                width={120}
                style={{ right: 0, left: 0, top: 0 }}
                className="position-absolute m-auto d-sm-none"
                alt="gif"
                src={require(`../../base/assets/images/scroll.gif`)}
              />
            )} */}
          </div>
          <ChairSamples />
        </div>
      </div>

      <div className="row mx-0 bg-light-gray p-2 rounded10 mt-2 justify-content-center small">
        {selectedTickets && selectedTickets.length !== 0 && (
          <div className="row mx-0 px-0 pb-2 mb-2 border-bottom border-dark">
            {selectedTickets.map((ticket, t) => (
              <div className="col-6 col-sm-4 col-md-3 p-1">
                <div className="row mx-0 bg-gray p-0 rounded10">
                  <div className="col px-0 fs-7 text-center py-2">
                    <p className="mb-0">بخش</p>
                    <p className="mb-0">{ticket.section}</p>
                  </div>
                  <div className="col px-0 fs-7 text-center py-2">
                    <p className="mb-0">ردیف</p>
                    <p className="mb-0">{ticket.row_number}</p>
                  </div>
                  <div className="col px-0 fs-7 text-center py-2">
                    <p className="mb-0">صندلی</p>
                    <p className="mb-0">{ticket.number}</p>
                  </div>
                  <div className="col-auto px-0 text-center bg-red rounded-left-10 py-0">
                    <button
                      className="btn py-0 px-1 h-100"
                      onClick={() =>
                        setSelectedTickets(
                          selectedTickets.filter(
                            (newticket) => newticket !== ticket
                          )
                        )
                      }
                    >
                      <BiTrash size={20} className="text-white h-100" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="col-auto px-0 align-self-center">
          <HiOutlineTicket size={20} />
        </div>
        <div className="col-auto px-2 fw-bolder align-self-center">
          {selectedTickets ? selectedTickets.length : 0}
        </div>
        <div className="col-auto ps-3 pe-0 border-dark border-start align-self-center">
          بلیت
        </div>
        <div className="col px-2 fw-bolder align-self-center">
          <span className="small ms-2">بهای نهایی با 10% ارزش افزوده:</span>
          {selectedTickets
            ? moneyFormat(plusNumbers(selectedTickets), null, "fw-bolder")
            : "0 تومان"}
        </div>
      </div>

      <div className="row mx-0 bg-light-gray px-2 py-3 rounded10 mt-2 justify-content-center">
        <div className="row mx-0" style={{ maxWidth: "370px" }}>
          {authConfirmMode ? (
            <>
              <div className="p-3">
                <p className="fs-7 d-inline-block text-secondary text-center">
                  {`لطفا کد ورود یکبار مصرف ارسال شده به شماره ${phone} را وارد کنید`}
                </p>
                <p className="fs-2 fw-bolder text-center">
                  {login_expire_time === 0 ? (
                    <button
                      className="btn fs-7 fw-bolder text-main"
                      onClick={() => auth()}
                    >
                      ارسال دوباره کد
                    </button>
                  ) : (
                    ~~(login_expire_time / 60) +
                    ":" +
                    (login_expire_time % 60 < 10
                      ? "0" + (login_expire_time % 60)
                      : login_expire_time % 60)
                  )}
                </p>
                <div className="position-relative mt-2">
                  <input
                    dir="ltr"
                    id="code"
                    className="form-control rounded14 fs-2 px-3 py-2-3 text-center"
                    placeholder="-   -   -   -   -"
                    type="tel"
                    maxLength="5"
                    value={code}
                    onChange={(e) =>
                      /^[0-9]*$/.test(fixNumbers(e.target.value)) &&
                      setCode(fixNumbers(e.target.value))
                    }
                    autoComplete={false}
                  />
                  {code && <Lable text="کد ورود یکبار مصرف" />}
                </div>
              </div>
              <button
                className="btn small text-white rounded14 bg-main mt-2 mb-3 w-100 py-2-3"
                disabled={code?.length !== 5 || confirmPending}
                onClick={() => authConfirm()}
              >
                {confirmPending ? (
                  <Spinner
                    className="align-middle"
                    animation="border"
                    size="sm"
                  />
                ) : (
                  "تایید"
                )}
              </button>
            </>
          ) : (
            <>
              <div className="col-12 px-0 position-relative mb-3">
                <input
                  id="name"
                  className={`form-control bg-light-gray text-center mx-auto px-3 py-2 rounded7 fs-7 ${
                    name && "fw-bolder"
                  }`}
                  placeholder="نام و نام خانوادگی*(اجباری)"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  maxLength="60"
                />
                {name && <Lable text="نام و نام خانوادگی*(اجباری)" />}
              </div>
              <div className="col-12 px-0 position-relative mb-3">
                <input
                  id="phone"
                  className={`form-control bg-light-gray mx-auto text-center px-3 py-2 rounded7 fs-7 ${
                    phone && "fw-bolder"
                  }`}
                  placeholder="تلفن همراه*(اجباری)"
                  value={phone}
                  onChange={(e) =>
                    /^[0-9]*$/.test(fixNumbers(e.target.value)) &&
                    setPhone(fixNumbers(e.target.value))
                  }
                  type="tel"
                  maxLength="11"
                />
                {phone && <Lable text="تلفن همراه*(اجباری)" />}
              </div>
            </>
          )}
          {acceptDiscount && !authConfirmMode ? (
            <span className="fs-8 fw-bolder mb-2 text-green">
              کد تخفیف اعمال شد
              <span
                className="me-3 text-red btn p-0 w-auto fs-8"
                onClick={() => {
                  setAcceptDiscount("");
                  setDiscount("");
                }}
              >
                <BsTrash size={16} />
                حذف کد تخفیف
              </span>
            </span>
          ) : showDiscount && !authConfirmMode ? (
            <div className="row mx-0 p-3 bg-white rounded7 mb-3">
              <div className="col-12 px-0 position-relative mb-2">
                <input
                  className={`form-control bg-white mx-auto px-3 py-2 rounded7 fs-7 ${
                    discount && "fw-bolder"
                  }`}
                  placeholder="کد تخفیف"
                  value={discount}
                  onChange={(e) =>
                    /^[0-9A-Za-z]*$/.test(fixNumbers(e.target.value)) &&
                    setDiscount(fixNumbers(e.target.value))
                  }
                  type="text"
                  maxLength="16"
                />
                {discount && <Lable class={"bg-white"} text="کد تخفیف" />}
              </div>
              <div className="col-12 px-0 text-center">
                <button
                  disabled={discountPending}
                  onClick={() => checkDiscount()}
                  className="btn rounded7 py-2-3 w-100 fs-7 fw-bolder px-4 text-center bg-dark text-white border-0"
                >
                  {discountPending ? (
                    <Spinner
                      size="sm"
                      className="align-middle text-white"
                      animation="border"
                    />
                  ) : (
                    "بکارگیری کد"
                  )}
                </button>
              </div>
              <div className="col-12 px-0 text-center">
                <span
                  className="fs-7 fw-bolder mt-2 btn p-0"
                  onClick={() => {
                    setShowDiscount(false);
                    setDiscount("");
                  }}
                >
                  بازگشت
                </span>
              </div>
            </div>
          ) : !authConfirmMode ? (
            <span
              className="fs-8 fw-bolder mb-2 btn p-0 w-auto"
              onClick={() => setShowDiscount(true)}
            >
              » کد تخفیف دارم
            </span>
          ) : (
            ""
          )}
          {!showDiscount && !authConfirmMode && (
            <div className="col-12 px-0 text-center mt-2">
              <button
                disabled={pending || confirmPending}
                onClick={() => (token ? pay() : auth())}
                className="btn rounded40 py-2-3 small fw-bolder text-white px-4 text-center bg-main-grad w-100 border-0"
              >
                {pending || confirmPending ? (
                  <Spinner
                    size="sm"
                    className="align-middle text-white"
                    animation="border"
                  />
                ) : (
                  "پرداخت"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
